import { render, staticRenderFns } from "./AllStores.vue?vue&type=template&id=b4dadb72&scoped=true"
import script from "./AllStores.vue?vue&type=script&lang=js"
export * from "./AllStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dadb72",
  null
  
)

export default component.exports